export const WISHLIST_AUTH_REQUIRED_ERROR = "WISHLIST_AUTH_REQUIRED";
export const WISHLIST_STORAGE_UNAVAILABLE_ERROR = "WISHLIST_STORAGE_UNAVAILABLE";
